import { render, staticRenderFns } from "./UserWithTags.vue?vue&type=template&id=31480fdd"
import script from "./UserWithTags.vue?vue&type=script&setup=true&lang=js"
export * from "./UserWithTags.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports